import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-alpha-common';
import { Card } from '@oneaudi/unified-web-alpha-components';

import styled from 'styled-components';

export const ItemCardStyle = styled(Card)`
	position: relative;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	img {
		aspect-ratio: 16 / 9;
		object-fit: cover;
		width: 100%;
	}

	.equipment-content {
		display: flex;
		padding: ${SYS_SPACE_FIXED_200};
		gap: 12px;
		flex-direction: column;
		height: 100%;

		.more-info {
			margin-top: auto;
			width: fit-content;
		}
	}

	.disclaimer-wrapper {
		margin-top: 4px;
		width: 100%;
	}
`;
